import * as React from "react";

const IconCaretUp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="currentColor"><polygon fill="currentColor" points="7.5 17.125 3.75 20.5 0 17.125 0 16 7.5 16" transform="matrix(1 0 0 -1 .25 20.5)"/></svg>;
};

export default React.memo(IconCaretUp);
